export default "__VITE_ASSET__YR5B_PcX__"